const KEY = 'sof-color-scheme';

function systemPrefersDark(): boolean {
  return window.matchMedia?.('(prefers-color-scheme: dark)')?.matches ?? false;
}

export function isDarkScheme(): boolean {
  const current = document.documentElement.dataset['colorScheme'];
  return current ? current === 'dark' : systemPrefersDark();
}

export function applySavedColorScheme(): void {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'dark' || saved === 'light') document.documentElement.dataset['colorScheme'] = saved;
  } catch {
    // Storage bloqueado: queda el tema del sistema.
  }
}

export function toggleColorScheme(): boolean {
  const next = isDarkScheme() ? 'light' : 'dark';
  document.documentElement.dataset['colorScheme'] = next;
  try {
    localStorage.setItem(KEY, next);
  } catch {
    // Sin persistencia: el cambio dura hasta recargar.
  }
  return next === 'dark';
}
